import { Injectable } from "@angular/core";
import { AEntraIdConnectionHttpService, ApiTestConnectionResult, EntraIdConnection } from "@coso/connection-forms";
import { Observable, of } from "rxjs";
import { catchError, flatMap } from "rxjs/operators";
import { handleError } from "../utils/handle-error";
import { ConnectionMapperService } from "./connection-mapper.service";
import { EntraIdConnectionService } from "./entra-id-connection.service";

@Injectable({
  providedIn: "root"
})
export class EntraIdConnectionHttpService extends AEntraIdConnectionHttpService {
  constructor(private entraIdConnection: EntraIdConnectionService, private connectionMapper: ConnectionMapperService) {
    super();
  }

  testConnection(configuration: EntraIdConnection): Observable<ApiTestConnectionResult> {
    const data = this.connectionMapper.mapFromEntraIdConnection(configuration);
    const instanceId = sessionStorage.getItem("instance-id");
    return this.entraIdConnection.testConnection(instanceId, data).pipe(
      flatMap((result) => {
        if (result.success) {
          return of({
            isSuccess: true,            
          });
        } else {
          return of({
            isSuccess: false,
            error: result.error
          });
        }
      }),
      catchError((error) => {
        return of({
          isSuccess: false,
          error: handleError(error)
        });
      })
    );
  }
}
